import React from 'react'
import { Button, Grid, Typography, FormControlLabel, Switch } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../PageTitle/PageTitle'

// data
import { FormLoader } from '../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../Services/Api/Configuration'
import UserServices from '../../../Services/Consumers/UserServices'
import { useHistory } from 'react-router-dom'
import { NamedRoutes } from '../../../routes'
import { filterData } from '../../../utils/helpers'
import { UserCompaniesFiltersPayload } from '../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import moment from 'moment'
import 'moment/locale/ar-ly'
import PermissionsList from './PermissionsList'
import RoleMenu from './RoleMenu'
import SubscriptionServices from '../../../Services/Consumers/SubscriptionServices'

let { User_Config } = Configuration
export default function RolesContent ({ handleNotificationCall, adminSectionType }) {
  let classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userPermissionsLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [canCreate, setCanCreate] = React.useState(false)
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'name',
      label: intl.formatMessage({ id: 'Roles.List.Table.RoleName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Roles.List.Table.RoleName'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'permissions',
      label: intl.formatMessage({ id: 'Roles.List.Table.Permissions' }),
      options: {
        filter: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          data[dataIndex] && <PermissionsList permissions={data[dataIndex].permissions}/>
        )
      }
    },
    {
      name: 'permissionNames',
      label: intl.formatMessage({ id: 'Roles.List.Table.Permissions' }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: false,
        print: true,
        download: true
      }
    },
    {
      name: 'is_admin_role',
      label: intl.formatMessage({ id: 'Roles.List.Table.isAdmin' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.Admin' }) : intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.NotAdmin' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Roles.List.Table.isAdmin'/>:
                <span>{!!v ? intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.Admin' }) : intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.NotAdmin' })}</span>
              </div>
            )
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.Admin' }) : intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.NotAdmin' })}
              value={value ? true : false}
              control={
                <Switch color="primary" disabled={'admin' === tableMeta.rowData[1]} checked={value}
                        value={value ? true : false}/>
              }
              onChange={(event) => {
                if ('admin' !== tableMeta.rowData[1]) {
                  let existPermissions = []
                  tableMeta.rowData[2].forEach((permission) => {
                    existPermissions.push(permission.id)
                  })
                  let roleObj = {
                    'name': tableMeta.rowData[1],
                    'permissions': existPermissions,
                    'is_admin_role': !JSON.parse(event.target.value)
                  }
                  updateValue(!JSON.parse(event.target.value))
                  roleIsAdmin(tableMeta.rowData[0], roleObj, !JSON.parse(event.target.value), updateValue)
                }
              }}
            />
          )
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        print: false,
        viewColumns: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (data[dataIndex] && 'admin' !== data[dataIndex].name && <RoleMenu
            index={dataIndex}
            data={data}
            setData={setData}
            count={count}
            setCount={setCount}
            adminSectionType={adminSectionType}
            handleNotificationCall={handleNotificationCall}/>)
        }
      }
    }
  ]
  const updateLoadedData = (roleId, newActiveValue) => {
    let newData = loadedData
    newData.forEach((roleData) => {
      roleData.forEach((role) => {
        if (roleId === role.id) {
          role.is_admin_role = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }
  const roleIsAdmin = (roleId, updatedRoleObject, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).updateRole(roleId, updatedRoleObject, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({
                id: newActiveValue ? 'Roles.List.Table.isAdmin.Success' :
                  'Roles.List.Table.NotAdmin.Success'
              }),
              color: 'success'
            }, 'success')
            updateLoadedData(roleId, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }
      })
    }
  }
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        ('subscription' === adminSectionType ? SubscriptionServices : UserServices).getRoles({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            setCanCreate(true)
            if (!!result && !!result.data && !!result.data.data) {
              let newData = result.data.data
              newData.forEach((role) => {
                let permissionNames = []
                role.permissions.forEach((permission) => permissionNames.push(permission.name))
                role['permissionNames'] = permissionNames
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('created_from_datetime' === columns[index].name || 'created_to_datetime' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).utc().format('DD-MM-YYYY HH:mm:ss')
        } else if ('is_admin_role' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    downloadOptions: {
      filename: `${intl.formatMessage({ id: 'Sidebar.Links.RolesAndPermissions' })}.csv`,
      separator: ','
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && column === 'created_from_datetime' && typeof type === 'string' && type === 'custom') ||
        (typeof column === 'string' && column === 'created_to_datetime' && typeof type === 'string' && type === 'custom')) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'ActivityLog.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.RolesAndPermissions'/>}
                 button={!!canCreate && <Button
                   classes={{ root: classes.button }}
                   variant="contained"
                   size="large"
                   color="primary"
                   onClick={() => {
                     history.push(NamedRoutes[adminSectionType].RolesAndPermissions.add)
                   }}
                 >
                   <FormattedMessage id='Roles.List.AddRole.Title'/>
                 </Button>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Sidebar.Links.RolesAndPermissions'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
